<script>
  import NavSettingsIcon from '$icons/NavSettingsIcon.svelte';
  import SubNavMessageDashIcon from '$icons/SubNavMessageDashIcon.svelte';
  import LogoutIcon from '$icons/LogoutIcon.svelte';
  import NavLeaderboardIcon from '$icons/NavLeaderboardIcon.svelte';
  import NavChallengesIcon from '$icons/NavChallengesIcon.svelte';
  import { clickOutside } from '$src/utils/clickOutside.util';
  import { createEventDispatcher } from 'svelte';
  import { me } from '$src/stores/user.store';
  import UserAvatarWrapper from '../common/user/userAvatarWrapper.svelte';
  import { goto } from '$app/navigation';
  import { logout } from '$src/utils/api/user.util';
  import { slide } from 'svelte/transition';
  import LoginIcon from '$icons/LoginIcon.svelte';
  import Media from '../common/media/Media.svelte';

  const dispatch = createEventDispatcher();

  const help = () => {
    dispatch('showHelpModal');
    dispatch('ModalClose');
  };
</script>

<div class="fixed left-0 right-0 h-screen bg-black bg-opacity-50 z-[160]">
  <div
    in:slide|global={{ axis: 'x', duration: 250 }}
    out:slide|global={{ axis: 'x', duration: 250 }}
    use:clickOutside
    on:click_outside={() => dispatch('ModalClose')}
    class="absolute h-screen bg-white w-4/5 z-[70]"
  >
    {#if $me?.coverImage}
      <div class="w-full h-40">
        <Media class="w-full h-full object-cover" src={$me?.coverImage} alt=" " />
      </div>
    {:else}
      <div class="w-full bg-gray-300 h-40">&nbsp;</div>
    {/if}

    <button class="p-4 border-b text-left w-full" on:click={() => goto('/profile')}>
      <div class="flex flex-row items-center mb-2">
        <div class="h-14 w-14 mr-3 flex items-center justify-center">
          <UserAvatarWrapper
            cls={'w-[90%] aspect-square'}
            profileImage={$me?.profileImage}
            userName={$me?.userName || 'No name'}
          />
        </div>
        <div>
          <p class="text-lg font-semibold text-grey-transparency-dark">{$me?.name || 'No name'}</p>
          <p class="font-thin text-grey-transparency-dark-56">@{$me?.userName || 'No username'}</p>
        </div>
      </div>

      <div class="flex flex-row gap-2">
        <div class="flex flex-row gap-1">
          <p class="font-satoshi text-grey-transparency-dark">{$me?.followersAmount || 0}</p>
          <p class="text-grey-transparency-dark-56">Followers</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="font-satoshi text-grey-transparency-dark">{$me?.followingUsersAmount || 0}</p>
          <p class="text-grey-transparency-dark-56">Following</p>
        </div>
      </div>
    </button>
    <div class="flex flex-col items-start pl-4 gap-6 mt-6">
      <div class="flex flex-row justify-between items-center w-full pr-4">
        <button
          on:click={() => goto('/leaderboard')}
          class="font-switzer text-grey-transparency-dark text-lg flex flex-row gap-2 items-center"
        >
          <NavLeaderboardIcon />
          Leaderboard
        </button>
      </div>
      <button
        class="font-switzer text-grey-transparency-dark text-lg flex flex-row gap-2 items-center"
        on:click={() => {
          help();
        }}
      >
        <SubNavMessageDashIcon />
        Help and Support
      </button>
      <button
        class="font-switzer text-grey-transparency-dark text-lg flex flex-row gap-2 items-center"
        on:click={() => {
          if (!$me) return;
          goto('/settings/profile');
        }}
      >
        <NavSettingsIcon />
        Settings
        {#if !$me}
          <div class="bg-red-100 py-1 px-2 rounded-full text-xs text-red-600">login required</div>
        {/if}
      </button>
    </div>
    {#if $me}
      <button
        class="text-lg absolute bottom-3 text-accent-red-50 pl-4 flex flex-row gap-2 items-center"
        on:click={() => logout()}
      >
        <LogoutIcon />
        Logout
      </button>
    {:else}
      <button
        class="text-lg absolute bottom-3 text-green-600 pl-4 flex flex-row gap-2 items-center"
        on:click={() => {
          dispatch('ModalClose');
          goto('/login');
        }}
      >
        <LoginIcon />
        Login
      </button>
    {/if}
  </div>
</div>
